import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { ArrowLeft, LockKey } from '@phosphor-icons/react';
import { toast } from 'sonner';
import AdminLoginForm from '@/components/admin/AdminLoginForm';

const handleLoginSubmit = async ({ event, login, email, password, setLoading, navigate }) => {
  event.preventDefault();
  setLoading(true);
  const result = await login(email, password);
  setLoading(false);
  if (result.success) {
    toast.success('Login successful!');
    navigate('/admin/dashboard');
  } else {
    toast.error(result.error);
  }
};

const LoginHeader = () => (
  <div className="text-center mb-8">
    <div className="w-16 h-16 bg-gradient-to-br from-slate-900 to-teal-600 rounded-lg flex items-center justify-center mx-auto mb-4">
      <LockKey size={32} weight="bold" className="text-white" />
    </div>
    <h1 className="text-2xl font-black text-slate-900 mb-2">Admin Login</h1>
    <p className="text-slate-600 text-sm">Access the SMART-Workflow admin dashboard</p>
  </div>
);

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = (e) => handleLoginSubmit({ event: e, login, email, password, setLoading, navigate });

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center py-12 px-6">
      <div className="max-w-md w-full">
        <Button
          variant="ghost"
          onClick={() => navigate('/')}
          className="mb-6"
          data-testid="back-to-home-button"
        >
          <ArrowLeft size={20} className="mr-2" />
          Back to Home
        </Button>
        <div className="bg-white border border-slate-200 rounded-lg p-8 shadow-sm">
          <LoginHeader />
          <AdminLoginForm
            email={email}
            password={password}
            loading={loading}
            onEmail={setEmail}
            onPassword={setPassword}
            onSubmit={onSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
